import { createContext } from 'react'

// Create and export the context
export const ScrollToTopContext = createContext(() => {})
